<template>
    <div class="shadow-sm bg-system-light rounded-2xl pt-4 pb-5 flex flex-col gap-6 grow basis-1">
        <div v-if="slots.header" class="px-4 md:px-6">
            <slot name="header"></slot>
        </div>
        <div v-if="slots.chart" class="px-2"><slot name="chart"></slot></div>
        <div v-if="slots.default" class="px-4 md:px-6 grow"><slot name="default"></slot></div>
    </div>
</template>

<script setup lang="ts">
    import { useSlots, type Slots } from 'vue'
    const slots: Slots = useSlots()
</script>
